// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar */
.sidebar-b {
  width: 216px;
  min-height: 100%;
  background: var(--ink-dark);
  color: var(--ink-text);
  position: relative;
  display: flex;
  flex-direction: column;
  /* The rail is a scroll container (the layout pins it to 100vh with
     overflow-y:auto). It must never scroll horizontally — without this, any
     child wider than 216px (a popup, a long label) makes overflow-x compute to
     auto and adds a stray horizontal scrollbar. */
  overflow-x: hidden;
}

.sidebar-b__brand {
  box-sizing: border-box;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 0 12px;
}

.sidebar-b__collapse-btn {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--ink-text-3);
  cursor: pointer;
  flex-shrink: 0;
}
.sidebar-b__collapse-btn:hover {
  background: var(--ink-rule);
  color: var(--ink-text);
}
.sidebar-b--collapsed .sidebar-b__collapse-btn {
  margin-left: 0;
}

.sidebar-b__brand-hammer {
  width: 30px;
  height: 30px;
  flex-shrink: 0;
}

/* Wordmark — serif lockup (RECEP 300 / THOR 600). Targets Newsreader but falls
   back to the serif token (Instrument Serif in this repo). */
.sidebar-b__wm {
  display: inline-flex;
  align-items: baseline;
  line-height: 1;
  font-size: 19px;
  color: var(--cream);
}
.sidebar-b__wm-a {
  font-family: 'Newsreader', var(--serif);
  font-weight: 300;
  letter-spacing: 0.04em;
}
.sidebar-b__wm-b {
  font-family: 'Newsreader', var(--serif);
  font-weight: 600;
  letter-spacing: 0.04em;
}

.sidebar-b__brand-rule {
  height: 1px;
  margin: 0 20px 16px;
  background: var(--ink-rule);
}

/* Single 14px gutter shared by section labels and nav items so the label
   text and the item icons sit on the same left grid line. */
.sidebar-b__nav-section {
  margin-bottom: 14px;
}

.sidebar-b__nav-section-label {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--ink-text-3);
  padding: 0 14px 8px;
}

.sidebar-b__nav-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 38px;
  padding: 0 14px;
  font-size: var(--fs-ui);
  color: var(--ink-text-2);
  cursor: pointer;
}

.sidebar-b__nav-item:hover {
  background: rgba(242, 227, 181, 0.06);
  color: var(--ink-text);
}

.sidebar-b__nav-item--active {
  color: var(--ink-text);
  background: rgba(12, 107, 240, 0.18);
  box-shadow: inset 3px 0 0 var(--signal);
}

/* Active-count tag on the right of a nav item: causas / diligencias / pagos
   show their live count. */
/* Trailing group on the right of a nav item — keeps count + kbd adjacent
   instead of letting space-between spread them apart. */
.sidebar-b__nav-item-end {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.sidebar-b__count {
  font-family: var(--mono);
  font-size: var(--fs-micro);
  font-variant-numeric: tabular-nums;
  color: var(--ink-text-3);
  flex-shrink: 0;
}
.sidebar-b__nav-item--active .sidebar-b__count {
  color: var(--cream);
}

/* Badge del nav — tag chico junto al label, con variantes:
   · (base) tag neutro · --ver: versión (cian sólido, "v2"). */
.sidebar-b__badge {
  font-family: var(--mono);
  font-size: var(--fs-pico);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.7;
  padding: 0 5px;
  border-radius: var(--radius-1);
  color: var(--ink-text-3);
  background: rgba(242, 227, 181, 0.1);
}
.sidebar-b__badge--ver {
  color: var(--ink-dark);
  background: var(--cyan);
}
.sidebar-b__nav-item--active .sidebar-b__badge {
  color: var(--cream);
}
.sidebar-b__nav-item--active .sidebar-b__badge--ver {
  color: var(--ink-dark);
}

.sidebar-b__nav-item-main {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.sidebar-b__icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  font-size: var(--fs-prose);
  color: currentColor;
  opacity: 0.85;
}

.sidebar-b__nav-item--active .sidebar-b__icon {
  opacity: 1;
}

.sidebar-b__kbd {
  font-family: var(--mono);
  font-size: var(--fs-pico);
  letter-spacing: 0.06em;
  color: var(--ink-text-3);
  background: rgba(242, 227, 181, 0.08);
  padding: 1px 5px;
  border-radius: 2px;
  flex-shrink: 0;
}

.sidebar-b__nav-item--active .sidebar-b__kbd {
  color: var(--cream);
}

/* Account + actions — pinned to the bottom as a footer row. */
.sidebar-b__footer {
  margin-top: auto;
}

/* Collapsed → narrow icon rail. */
/* Collapsed rail = 46px so a centered 18px icon lands at left:14px / center:23px —
   identical to the expanded item (padding-left 14). The brand keeps its 0 12px
   padding so the hammer stays at the same x too. Net: nothing moves horizontally
   when toggling, only labels appear/disappear. */
.sidebar-b--collapsed {
  width: 46px;
}

.sidebar-b--collapsed .sidebar-b__brand {
  padding: 0 12px;
}

.sidebar-b--collapsed .sidebar-b__nav-section {
  padding: 0;
}

/* Collapsed rail shows icons only — no group labels. */
.sidebar-b--collapsed .sidebar-b__nav-section-label {
  display: none;
}

/* Same single divider under the brand as the open sidebar. */
.sidebar-b--collapsed .sidebar-b__brand-rule {
  margin: 0 10px 16px;
}

/* Same vertical spacing as the expanded item (open state governs) so icons
   keep their position when toggling. */
.sidebar-b--collapsed .sidebar-b__nav-item {
  justify-content: center;
  padding: 0;
}

/* Account menu — sidebar footer. Popup reuses the shared DropdownMenu, opening
   upward. */
.sidebar-b__acct {
  position: relative;
  border-top: 1px solid var(--ink-rule);
  padding: 8px;
}
.sidebar-b__acct-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px;
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius-1, 2px);
  color: var(--ink-text-2);
  text-align: left;
  cursor: pointer;
  font: inherit;
}
.sidebar-b__acct-btn:hover,
.sidebar-b__acct--open .sidebar-b__acct-btn {
  background: var(--ink-dark-2);
  color: var(--ink-text);
}
.sidebar-b__acct-av {
  width: 30px;
  height: 30px;
  flex: none;
  display: grid;
  place-items: center;
  background: var(--signal);
  color: #fff;
  font-family: var(--mono);
  font-size: var(--fs-sm);
  font-weight: 600;
}
.sidebar-b__acct-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.sidebar-b__acct-name {
  font-size: var(--fs-2xs);
  font-weight: 500;
  color: var(--ink-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-b__acct-studio {
  font-family: var(--mono);
  font-size: var(--fs-nano);
  color: var(--ink-text-3);
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sidebar-b__acct-caret {
  color: var(--ink-text-3);
  flex: none;
  font-size: var(--fs-micro);
  line-height: 1;
}
.sidebar-b__acct-menu {
  position: fixed;
  left: 8px;
  bottom: 64px;
  width: 232px;
  z-index: var(--z-dropdown, 1000);
  /* The menu is fixed and grows UPWARD from the footer. Cap its height so a tall
     panel (the org drill-in) can never climb over the sticky topbar — it stops
     ~12px below the bar and scrolls internally instead. */
  max-height: calc(100vh - var(--lb-topbar-h, 52px) - 76px);
  overflow-y: auto;
}
/* The shared DropdownMenu defaults to position:absolute / top:100% (it opens
   downward from a topbar trigger). In the sidebar footer it must flow inside this
   fixed, bottom-anchored wrapper so it opens UPWARD and escapes the rail's scroll
   box (otherwise its 240px width + downward height add H+V scrollbars to the rail). */
.sidebar-b__acct-menu .dd-menu {
  position: static;
  width: 100%;
}
.sidebar-b--collapsed .sidebar-b__acct {
  padding: 8px 0;
}
.sidebar-b--collapsed .sidebar-b__acct-btn {
  justify-content: center;
  padding: 8px 0;
}
.sidebar-b--collapsed .sidebar-b__acct-menu {
  left: 8px;
  width: 232px;
}

/* ── Org sub-view (drill-in panel) ─────────────────────────────────────── */

/* Back button inherits .dd-menu__item; no extra style needed beyond the icon. */
.dd-menu__item--back {
  font-weight: 500;
}

/* Org row: avatar square + info column + trailing check/arrow */
.dd-menu__item--org {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dd-menu__org-av {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-0);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
}

.dd-menu__org-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.dd-menu__org-name {
  font-size: var(--fs-ui);
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dd-menu__org-meta {
  font-size: var(--fs-sm);
  opacity: 0.55;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dd-menu__org-check {
  flex-shrink: 0;
  font-size: var(--fs-ui);
  font-weight: 600;
  color: var(--accent);
  margin-left: auto;
}

.dd-menu__org-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  opacity: 0.4;
  margin-left: auto;
}

/* Muted note at the bottom of the org sub-view */
.dd-menu__org-note {
  margin: 0;
  padding: 8px 14px 10px;
  font-size: var(--fs-sm);
  line-height: 1.5;
  opacity: 0.5;
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB;;;kDAGgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;6DAC6D;AAC7D;EACE,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;4DAC4D;AAC5D;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;2BAC2B;AAC3B;wDACwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,kCAAkC;EAClC,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA;8DAC8D;AAC9D;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,wBAAwB;EACxB,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;;;iDAGiD;AACjD;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;AACrB;;AAEA;uCACuC;AACvC;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;YACY;AACZ;EACE,kBAAkB;EAClB,qCAAqC;EACrC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;;EAEE,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC;;0DAEwD;EACxD,yDAAyD;EACzD,gBAAgB;AAClB;AACA;;;sFAGsF;AACtF;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,SAAS;EACT,YAAY;AACd;;AAEA,6EAA6E;;AAE7E,gFAAgF;AAChF;EACE,gBAAgB;AAClB;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iDAAiD;AACjD;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB","sourcesContent":["/* Sidebar */\n.sidebar-b {\n  width: 216px;\n  min-height: 100%;\n  background: var(--ink-dark);\n  color: var(--ink-text);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  /* The rail is a scroll container (the layout pins it to 100vh with\n     overflow-y:auto). It must never scroll horizontally — without this, any\n     child wider than 216px (a popup, a long label) makes overflow-x compute to\n     auto and adds a stray horizontal scrollbar. */\n  overflow-x: hidden;\n}\n\n.sidebar-b__brand {\n  box-sizing: border-box;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n  padding: 0 12px;\n}\n\n.sidebar-b__collapse-btn {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--ink-text-3);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n.sidebar-b__collapse-btn:hover {\n  background: var(--ink-rule);\n  color: var(--ink-text);\n}\n.sidebar-b--collapsed .sidebar-b__collapse-btn {\n  margin-left: 0;\n}\n\n.sidebar-b__brand-hammer {\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n}\n\n/* Wordmark — serif lockup (RECEP 300 / THOR 600). Targets Newsreader but falls\n   back to the serif token (Instrument Serif in this repo). */\n.sidebar-b__wm {\n  display: inline-flex;\n  align-items: baseline;\n  line-height: 1;\n  font-size: 19px;\n  color: var(--cream);\n}\n.sidebar-b__wm-a {\n  font-family: 'Newsreader', var(--serif);\n  font-weight: 300;\n  letter-spacing: 0.04em;\n}\n.sidebar-b__wm-b {\n  font-family: 'Newsreader', var(--serif);\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n\n.sidebar-b__brand-rule {\n  height: 1px;\n  margin: 0 20px 16px;\n  background: var(--ink-rule);\n}\n\n/* Single 14px gutter shared by section labels and nav items so the label\n   text and the item icons sit on the same left grid line. */\n.sidebar-b__nav-section {\n  margin-bottom: 14px;\n}\n\n.sidebar-b__nav-section-label {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--ink-text-3);\n  padding: 0 14px 8px;\n}\n\n.sidebar-b__nav-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 38px;\n  padding: 0 14px;\n  font-size: var(--fs-ui);\n  color: var(--ink-text-2);\n  cursor: pointer;\n}\n\n.sidebar-b__nav-item:hover {\n  background: rgba(242, 227, 181, 0.06);\n  color: var(--ink-text);\n}\n\n.sidebar-b__nav-item--active {\n  color: var(--ink-text);\n  background: rgba(12, 107, 240, 0.18);\n  box-shadow: inset 3px 0 0 var(--signal);\n}\n\n/* Active-count tag on the right of a nav item: causas / diligencias / pagos\n   show their live count. */\n/* Trailing group on the right of a nav item — keeps count + kbd adjacent\n   instead of letting space-between spread them apart. */\n.sidebar-b__nav-item-end {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n.sidebar-b__count {\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  font-variant-numeric: tabular-nums;\n  color: var(--ink-text-3);\n  flex-shrink: 0;\n}\n.sidebar-b__nav-item--active .sidebar-b__count {\n  color: var(--cream);\n}\n\n/* Badge del nav — tag chico junto al label, con variantes:\n   · (base) tag neutro · --ver: versión (cian sólido, \"v2\"). */\n.sidebar-b__badge {\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  line-height: 1.7;\n  padding: 0 5px;\n  border-radius: var(--radius-1);\n  color: var(--ink-text-3);\n  background: rgba(242, 227, 181, 0.1);\n}\n.sidebar-b__badge--ver {\n  color: var(--ink-dark);\n  background: var(--cyan);\n}\n.sidebar-b__nav-item--active .sidebar-b__badge {\n  color: var(--cream);\n}\n.sidebar-b__nav-item--active .sidebar-b__badge--ver {\n  color: var(--ink-dark);\n}\n\n.sidebar-b__nav-item-main {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n}\n\n.sidebar-b__icon {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  font-size: var(--fs-prose);\n  color: currentColor;\n  opacity: 0.85;\n}\n\n.sidebar-b__nav-item--active .sidebar-b__icon {\n  opacity: 1;\n}\n\n.sidebar-b__kbd {\n  font-family: var(--mono);\n  font-size: var(--fs-pico);\n  letter-spacing: 0.06em;\n  color: var(--ink-text-3);\n  background: rgba(242, 227, 181, 0.08);\n  padding: 1px 5px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.sidebar-b__nav-item--active .sidebar-b__kbd {\n  color: var(--cream);\n}\n\n/* Account + actions — pinned to the bottom as a footer row. */\n.sidebar-b__footer {\n  margin-top: auto;\n}\n\n/* Collapsed → narrow icon rail. */\n/* Collapsed rail = 46px so a centered 18px icon lands at left:14px / center:23px —\n   identical to the expanded item (padding-left 14). The brand keeps its 0 12px\n   padding so the hammer stays at the same x too. Net: nothing moves horizontally\n   when toggling, only labels appear/disappear. */\n.sidebar-b--collapsed {\n  width: 46px;\n}\n\n.sidebar-b--collapsed .sidebar-b__brand {\n  padding: 0 12px;\n}\n\n.sidebar-b--collapsed .sidebar-b__nav-section {\n  padding: 0;\n}\n\n/* Collapsed rail shows icons only — no group labels. */\n.sidebar-b--collapsed .sidebar-b__nav-section-label {\n  display: none;\n}\n\n/* Same single divider under the brand as the open sidebar. */\n.sidebar-b--collapsed .sidebar-b__brand-rule {\n  margin: 0 10px 16px;\n}\n\n/* Same vertical spacing as the expanded item (open state governs) so icons\n   keep their position when toggling. */\n.sidebar-b--collapsed .sidebar-b__nav-item {\n  justify-content: center;\n  padding: 0;\n}\n\n/* Account menu — sidebar footer. Popup reuses the shared DropdownMenu, opening\n   upward. */\n.sidebar-b__acct {\n  position: relative;\n  border-top: 1px solid var(--ink-rule);\n  padding: 8px;\n}\n.sidebar-b__acct-btn {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px;\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius-1, 2px);\n  color: var(--ink-text-2);\n  text-align: left;\n  cursor: pointer;\n  font: inherit;\n}\n.sidebar-b__acct-btn:hover,\n.sidebar-b__acct--open .sidebar-b__acct-btn {\n  background: var(--ink-dark-2);\n  color: var(--ink-text);\n}\n.sidebar-b__acct-av {\n  width: 30px;\n  height: 30px;\n  flex: none;\n  display: grid;\n  place-items: center;\n  background: var(--signal);\n  color: #fff;\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n}\n.sidebar-b__acct-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.sidebar-b__acct-name {\n  font-size: var(--fs-2xs);\n  font-weight: 500;\n  color: var(--ink-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sidebar-b__acct-studio {\n  font-family: var(--mono);\n  font-size: var(--fs-nano);\n  color: var(--ink-text-3);\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.sidebar-b__acct-caret {\n  color: var(--ink-text-3);\n  flex: none;\n  font-size: var(--fs-micro);\n  line-height: 1;\n}\n.sidebar-b__acct-menu {\n  position: fixed;\n  left: 8px;\n  bottom: 64px;\n  width: 232px;\n  z-index: var(--z-dropdown, 1000);\n  /* The menu is fixed and grows UPWARD from the footer. Cap its height so a tall\n     panel (the org drill-in) can never climb over the sticky topbar — it stops\n     ~12px below the bar and scrolls internally instead. */\n  max-height: calc(100vh - var(--lb-topbar-h, 52px) - 76px);\n  overflow-y: auto;\n}\n/* The shared DropdownMenu defaults to position:absolute / top:100% (it opens\n   downward from a topbar trigger). In the sidebar footer it must flow inside this\n   fixed, bottom-anchored wrapper so it opens UPWARD and escapes the rail's scroll\n   box (otherwise its 240px width + downward height add H+V scrollbars to the rail). */\n.sidebar-b__acct-menu .dd-menu {\n  position: static;\n  width: 100%;\n}\n.sidebar-b--collapsed .sidebar-b__acct {\n  padding: 8px 0;\n}\n.sidebar-b--collapsed .sidebar-b__acct-btn {\n  justify-content: center;\n  padding: 8px 0;\n}\n.sidebar-b--collapsed .sidebar-b__acct-menu {\n  left: 8px;\n  width: 232px;\n}\n\n/* ── Org sub-view (drill-in panel) ─────────────────────────────────────── */\n\n/* Back button inherits .dd-menu__item; no extra style needed beyond the icon. */\n.dd-menu__item--back {\n  font-weight: 500;\n}\n\n/* Org row: avatar square + info column + trailing check/arrow */\n.dd-menu__item--org {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.dd-menu__org-av {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-0);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 0.02em;\n}\n\n.dd-menu__org-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.dd-menu__org-name {\n  font-size: var(--fs-ui);\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dd-menu__org-meta {\n  font-size: var(--fs-sm);\n  opacity: 0.55;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dd-menu__org-check {\n  flex-shrink: 0;\n  font-size: var(--fs-ui);\n  font-weight: 600;\n  color: var(--accent);\n  margin-left: auto;\n}\n\n.dd-menu__org-arrow {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  opacity: 0.4;\n  margin-left: auto;\n}\n\n/* Muted note at the bottom of the org sub-view */\n.dd-menu__org-note {\n  margin: 0;\n  padding: 8px 14px 10px;\n  font-size: var(--fs-sm);\n  line-height: 1.5;\n  opacity: 0.5;\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
